import { updatePasswordIssueMessages } from '@pyranger/types';
import type { ZodIssue } from 'zod';
import { useDeepCompareMemo } from 'use-deep-compare';
import _cx from 'classnames';
import { CheckIcon } from '@heroicons/react/24/solid';

interface PasswordRequirementsProps {
    didSubmit: boolean;
    issues: ZodIssue[] | null;
}

const issueMessages = Array.from(updatePasswordIssueMessages);

export function PasswordRequirements({
    didSubmit,
    issues,
}: PasswordRequirementsProps) {
    const items = useDeepCompareMemo(() => {
        return issueMessages.map(([key, message]) => ({
            key,
            message,
            valid: !(issues ?? []).some((issue) => issue.message === message),
        }));
    }, [issues, issueMessages]);

    return (
        <ul className="list-none">
            {items.map(({ key, message, valid }) => {
                const showError = didSubmit && !valid;
                const showCheck = didSubmit && valid;

                return (
                    <li
                        className={_cx('flex items-center', {
                            'text-danger-700': showError,
                        })}
                        key={key}
                    >
                        <div className="flex h-4 w-4 items-center justify-center">
                            {!showCheck && <div>•</div>}
                            {showCheck && <CheckIcon className="h-4 w-4" />}
                        </div>
                        <span className="pl-1">{message}</span>
                    </li>
                );
            })}
        </ul>
    );
}

export default PasswordRequirements;
